export default __webpack_public_path__ + "static/media/partner (10).812914fb.png";